export interface NavItem
{
	pageId: string | null;
	pageName: string;
	displayName: string;
	disabled?: boolean;
	iconName?: string;
	route?: string;
	children?: NavItem[];
	action?: string | string[];
	visible?: true;
	hidden?: boolean;
	badge?: number;
}
